import { i18n } from 'src/i18n';
import FormTemplateService from 'src/modules/formTemplate/formTemplateService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';
import formTemplateListActions from '../list/formTemplateListActions';

const prefix = 'FORMTEMPLATE_FORM';

const formTemplateFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: formTemplateFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await FormTemplateService.find(id);
      }

      dispatch({
        type: formTemplateFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formTemplateFormActions.INIT_ERROR,
      });

      getHistory().push('/form-template');
    }
  },

  doCopy: (values) => async (dispatch) => {
    try {
      dispatch({
        type: formTemplateFormActions.CREATE_STARTED,
      });

      await FormTemplateService.create(values);

      dispatch({
        type: formTemplateFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.formTemplate.create.success'),
      );

      dispatch(formTemplateListActions.doCopyFetch());
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formTemplateFormActions.CREATE_ERROR,
      });
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: formTemplateFormActions.CREATE_STARTED,
      });

      await FormTemplateService.create(values);

      dispatch({
        type: formTemplateFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.formTemplate.create.success'),
      );

      getHistory().push('/form-template');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formTemplateFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: formTemplateFormActions.UPDATE_STARTED,
      });

      await FormTemplateService.update(id, values);

      dispatch({
        type: formTemplateFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.formTemplate.update.success'),
      );

      getHistory().push('/form-template');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formTemplateFormActions.UPDATE_ERROR,
      });
    }
  },

  doUpdateWithoutRefreshing:
    (id, values) => async (dispatch, _getState) => {
      try {
        dispatch({
          type: formTemplateFormActions.UPDATE_STARTED,
        });

        await FormTemplateService.update(id, values);

        dispatch({
          type: formTemplateFormActions.UPDATE_SUCCESS,
        });

        Message.success(
          i18n('entities.formTemplate.update.success'),
        );

        dispatch(
          formTemplateListActions.doFetchCurrentFilter(),
        );
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: formTemplateFormActions.UPDATE_ERROR,
        });
      }
    },
};

export default formTemplateFormActions;
